<template>
  <header class="" style="margin-top: 2em; text-align: center;">
     <!-- 标题部分 -->
     <section class="hero-banner text-center py-5">
        <div class="container">
          <h1 class="display-4 fw-bold mb-3">{{ title }}</h1>
          <p class="lead text-muted">{{ subtitle }}</p>
          <div class="underline mx-auto"></div>
        </div>
      </section>


  </header>
</template>

<script>
export default {
  name: 'SimpleHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
 .underline {
    width: 80px;
    height: 3px;
    background: #0d6efd;
    margin-top: 1rem;
  }
</style>